// extracted by mini-css-extract-plugin
export var component = "title-module--component--iiKrB";
export var light = "title-module--light--8HWLS";
export var strong = "title-module--strong--DUT2N";